<template>
    <f7-page class="page-my-childs" @page:init="pageMounted" @page:reinit="pageMounted">
        <f7-navbar :sliding="false">
            <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>
                <a @click.prevent="openAgent" class="non-select">ĐẠI LÝ</a>
            </f7-nav-title>
            <f7-nav-right v-if="is_verified">
                <f7-link icon-ios="f7:ellipsis_vertical" popover-open=".popover-menu-agent-more"></f7-link>
            </f7-nav-right>
        </f7-navbar>
        <template v-if="is_verified">
            <f7-block strong class="mt-0">
                <f7-chip v-for="(item, idx) in breadcrumbs" :key="idx" :text="item.username" @click.prevent="clickChip(item, idx)" class="mr-05">
                    <img slot="media" :src="require('@/assets/images/no-avatar.png')"/>
                </f7-chip>
            </f7-block>
            <f7-block strong inset class="alert-notice text-bigger mt-1" v-if="announcements.length > 1">
                <span v-html="announcements[1].content"></span>
            </f7-block>
            <f7-row v-if="breadcrumbs.length > 0" class="mb-1">
                <f7-col>
                    <div>Có <strong>{{ current_childs.length }} TK</strong> thuộc đại lý <strong> {{ breadcrumbs[breadcrumbs.length - 1].username }}</strong></div>
                    <div>Trong đó có <strong>{{ monthly_bonus_satisfied }} TK</strong> thỏa điều kiện tặng thưởng</div>
                </f7-col>
            </f7-row>
            <f7-block class="mt-1 mb-2" inset>
                <f7-segmented strong tag="p">
                    <f7-button :active="tab_active === 'MGT'" @click.prevent="tab_active = 'MGT'">
                        MGT
                    </f7-button>
                    <f7-button :active="tab_active === 'simple'" @click.prevent="tab_active = 'simple'">
                        TRUYỀN THỐNG
                    </f7-button>
                </f7-segmented>
            </f7-block>
            <f7-list media-list class="search-list mt-0">
                <f7-list-input
                    type="text"
                    outline
                    floating-label
                    label="Tìm kiếm"
                    placeholder="Tìm kiếm"
                    :value="search"
                    @input="search = $event.target.value"
                >
                </f7-list-input>
                <f7-list-item v-for="(item, idx) in filtered_childs" :key="idx" :subtitle="`${item.system_credit} Credit`" @click.prevent="getChilds(item.username, item.fullname), search = ''" :text="item.note">
                    <span slot="title">
                        <span :class="{'text-color-crimson': item.account_type === 4}">{{ item.username }}</span>
                        <span v-if="item.is_dealer === true">
                            (Cấp {{ item.franchise_level }})
                        </span>
                        <span class="text-color-crimson" v-if="item.login_lock">[Đang khoá]</span>
                        <f7-icon class="text-color-forestgreen" f7="checkmark" v-if="item.monthly_bonus_satisfy" size="16px"></f7-icon>
                        <span v-if="item.franchise_percent !== null"> ({{ item.franchise_percent }}%)</span>
                    </span>
                    <div slot="after-title" class="item-after">
                        <span>{{ item.total_children_active }} / {{ item.total_children }} TK</span>
                        <f7-link z-index="999" icon-f7="ellipsis_vertical" @click.stop="item_selected = item" popover-open=".popover-menu-agent"></f7-link>
                    </div>
                </f7-list-item>
            </f7-list>
        </template>
        <f7-block v-else-if="is_loading" strong>
            Đang tải dữ liệu...
        </f7-block>
        <f7-block v-else strong>
            Không có cấp dưới
        </f7-block>
        <f7-block strong inset class="alert-notice text-bigger mt-1" v-if="announcements.length > 0">
            <span v-html="announcements[0].content"></span>
        </f7-block>
        <f7-popover class="popover-menu-agent">
            <f7-list>
                <f7-list-item link popover-close
                              @click="openPromptChangePassword" v-if="user_info.permissions.resetSimpleAccountPassword === 1 && item_selected.account_type === 4 && breadcrumbs.length === 1"
                              title="Đổi mật khẩu">
                    <f7-icon slot="media" f7="lock"></f7-icon>
                </f7-list-item>
                <f7-list-item link popover-close
                              @click="toggleLockLogin(item_selected.login_lock ? 0 : 1)"
                              v-if="user_info.permissions.loginLockSimpleAccount === 1 && item_selected.account_type === 4 && breadcrumbs.length === 1"
                              :title="item_selected.login_lock ? 'Mở khóa TK' : 'Khóa TK'">
                    <f7-icon slot="media" f7="lock"></f7-icon>
                </f7-list-item>
                <f7-list-item link popover-close
                              @click="promoteSimpleAccount"
                              v-if="user_info.permissions.promoteSimpleAccount === 1 && item_selected.account_type === 4 && item_selected.is_dealer === false && breadcrumbs.length === 1"
                              title="Cấp quyền Đại lý">
                    <f7-icon slot="media" f7="person_3"></f7-icon>
                </f7-list-item>
                <f7-list-item link popover-close
                              @click="openDialogFranchisePercent"
                              v-if="user_info.permissions.createSimpleAccount === 1 && item_selected.account_type === 4 && breadcrumbs.length === 1"
                              title="Hoa hồng">
                    <f7-icon slot="media" f7="percent"></f7-icon>
                </f7-list-item>
                <f7-list-item link popover-close @click="goToBuyCreditForUser" title="Nạp Credit">
                    <f7-icon slot="media" f7="money_dollar_circle"></f7-icon>
                </f7-list-item>
                <f7-list-item link popover-close @click="writeChildNote" title="Ghi chú">
                    <f7-icon slot="media" f7="pencil_ellipsis_rectangle"></f7-icon>
                </f7-list-item>
            </f7-list>
        </f7-popover>
        <f7-popover class="popover-menu-agent-more">
            <f7-list>
                <f7-list-item link popover-close href="#!" @click="goCreateSimpleAccount" title="Tạo TK" v-if="user_info.permissions.createSimpleAccount === 1">
                    <f7-icon slot="media" f7="person_badge_plus"></f7-icon>
                </f7-list-item>
                <f7-list-item link="/hoa-hong-gioi-thieu" popover-close title="Hoa hồng giới thiệu">
                    <f7-icon slot="media" f7="percent"></f7-icon>
                </f7-list-item>
            </f7-list>
        </f7-popover>
    </f7-page>
</template>
<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            is_loading: false,
            password: '',
            is_verified: false,
            clicked: 0,
            breadcrumbs: [],
            current_childs: [],
            item_selected: {},
            announcements: [],
            tab_active: 'MGT',
            search: ''
        }
    },
    computed: {
        ...mapState(['user_info']),
        monthly_bonus_satisfied(){
            return this._.filter(this.current_childs, { monthly_bonus_satisfy: true}).length;
        },
        filtered_childs(){
            let self = this;
            if (this.tab_active === 'MGT'){
                return this._.orderBy(this._.filter(this.current_childs, function(o){
                    return ((self.search === '' && o.account_type !== 4) || (o.account_type !== 4 && o.username.toLowerCase().indexOf(self.search.toLowerCase()) >= 0))
                }), ['system_credit', 'total_children'], ['desc', 'desc']);
            } else {
                return this._.orderBy(this._.filter(this.current_childs, function(o){
                    return ((self.search === '' && o.account_type === 4) || (o.account_type === 4 && o.username.toLowerCase().indexOf(self.search.toLowerCase()) >= 0))
                }),['system_credit', 'total_children'], ['desc', 'desc']);
            }
        }
    },
    methods: {
        getChilds(username, fullname, breadcrumbs_push = 1) {
            const self = this;

            this.current_childs = [];
            this.is_loading = true;

            this.$f7.preloader.show();

            this.$store.dispatch('getUserChilds', { username: username, level2_password: this.password })
                .then((data) => {
                    if (breadcrumbs_push === 1) {
                        self.breadcrumbs.push({
                            username: username,
                            fullname: fullname
                        });
                    }

                    this.$f7.preloader.hide();
                    this.is_loading = false;
                    this.is_verified = true;
                    this.current_childs = data;
                })
                .catch((error) => {
                    this.$f7.preloader.hide();
                    this.is_loading = false;
                    this.$f7.dialog.alert(error, 'LỖI');
                });
        },
        refreshChilds() {
            this.getChilds(this.breadcrumbs[this.breadcrumbs.length - 1].username, this.breadcrumbs[this.breadcrumbs.length - 1].fullname, 0);
        },
        clickChip(item, idx) {
            this.breadcrumbs.length = idx;
            this.search = '';

            this.getChilds(item.username, item.fullname);
        },
        goToBuyCreditForUser() {
            this.$f7router.navigate('/mua-credit', {
                props: {
                    buy_for_user: this.item_selected.username
                }
            });
        },
        writeChildNote() {
            const self = this;
            this.$f7.dialog.prompt('Nhập nội dung ghi chú', 'GHI CHÚ', (note) => {
                self.$f7.preloader.show();
                self.$store.dispatch('writeChildNote', { username: this.item_selected.username, note: note })
                    .then(() => {
                        self.$f7.preloader.hide();
                        self.$f7.dialog.alert('Đã lưu!', 'SUCCESS!', () => {
                            this.refreshChilds();
                        });
                    })
                    .catch((error) => {
                        self.$f7.preloader.hide();
                        self.$f7.dialog.alert(error, 'LỖI!');
                    })
            })
        },
        openAgent() {
            const self = this;
            if (this.clicked < 6) {
                this.clicked += 1;
                return false;
            }

            this.clicked = 0;
            this.$f7.dialog.password('Vui lòng nhập Mật khẩu cấp 2', 'CẢNH BÁO', (password) => {
                self.password = password;
                self.getChilds(self.user_info.username, self.user_info.fullname);
            })
        },
        getAnnouncements() {
            this.$store.dispatch('getAnnouncements', {
                position: 'agentpage',
                limit: 2
            }).then((data) => {
                this.announcements = data;
            });
        },
        goCreateSimpleAccount(){
            const self = this;
            this.$f7router.navigate('/tao-tai-khoan-khach', {
                props: {
                    referal: self.user_info.username
                }
            });
        },
        openPromptChangePassword() {
            const self = this;
            this.$f7.dialog.prompt('Nhập mật khẩu mới (8 chữ số)', 'ĐỔI MẬT KHẨU', (password) => {
                self.$f7.preloader.show();
                self.$store.dispatch('changePasswordSimple', { username: self.item_selected.username, password: password })
                    .then(() => {
                        self.$f7.preloader.hide();
                        self.$f7.dialog.alert('Đã đổi mật khẩu thành công', 'SUCCESS!');
                    })
                    .catch((error) => {
                        self.$f7.preloader.hide();
                        self.$f7.dialog.alert(error, 'LỖI!');
                    })
            })
        },
        toggleLockLogin(lock_status) {
            const self = this;
            self.$store.dispatch('toggleLockLogin', {
                    username: self.item_selected.username,
                    login_lock: lock_status
                })
                .then(() => {
                    self.$f7.preloader.hide();
                    self.$f7.dialog.alert(lock_status ? 'Đã khóa tài khoản' : 'Đã mở khóa tài khoản', 'SUCCESS!');
                    self.refreshChilds();
                })
                .catch((error) => {
                    self.$f7.preloader.hide();
                    self.$f7.dialog.alert(error, 'LỖI!');
                })
        },
        promoteSimpleAccount() {
            const self = this;
            let step = self.user_info.mentor_info.franchise_percent / 5;
            let buttons = [];
            for(let i = 1 ; i <= step ; i++){
                let percent = 5 * i;
                if (percent < self.item_selected.franchise_child_precent_min) {
                    continue;
                }
                buttons.push({
                    text: percent + '%',
                    onClick: function() {
                        self.$f7.dialog.close();
                        self.setPromoteAndFranchisePercent(self.item_selected.username, percent);
                    }
                });
            }
            self.$f7.dialog.confirm('Bạn có chắc chắn cấp quyền đại lý cho tài khoản ' + self.item_selected.username + ' ?', 'THÔNG BÁO!', () => {
                self.$f7.dialog.create({
                    title: 'Mức hoa hồng muốn cấp cho đại lý',
                    buttons: buttons,
                    verticalButtons: true,
                }).open();
            });
        },
        setPromoteAndFranchisePercent(username, percent) {
            const self = this;
            self.$f7.preloader.show();

            self.$store.dispatch('promoteSimpleAccount', {
                    username: username
                })
                .then(() => {
                    return self.$store.dispatch('setFranchisePercent', {
                        ref_username: username,
                        ref_franchise_percent: percent
                    });
                })
                .then(() => {
                    self.$f7.preloader.hide();
                    self.$f7.dialog.alert('Đã nâng cấp thành công', 'SUCCESS!');
                    self.refreshChilds();
                })
                .catch((error) => {
                    self.$f7.preloader.hide();
                    self.$f7.dialog.alert(error, 'LỖI!');
                });
        },
        openDialogFranchisePercent(){
            const self = this;
            let step = self.user_info.mentor_info.franchise_percent / 5;
            let buttons = [];
            for(let i = 0; i <= step ; i++){
                let percent = 5 * i;
                if(percent < self.item_selected.franchise_child_precent_min){
                    continue;
                }
                buttons.push({
                    text: percent + '%',
                    onClick: function() {
                        self.$f7.dialog.close();
                        self.setFranchisePercent(percent);
                    }
                });
            }
            buttons.push({
                text: 'Hủy',
                onClick: function() {
                    self.$f7.dialog.close();
                }
            });
            self.$f7.dialog.create({
                title: 'Mức hoa hồng muốn cấp cho đại lý',
                buttons: buttons,
                verticalButtons: true,
                closeByBackdropClick: true
            }).open();
        },
        setFranchisePercent(percent) {
            const self = this;
            self.$f7.preloader.show();
            self.$store.dispatch('setFranchisePercent', {
                    ref_username: self.item_selected.username,
                    ref_franchise_percent: percent
                })
                .then(() => {
                    self.$f7.preloader.hide();
                    self.$f7.dialog.alert('Đã cập nhật phần trăm hoa hồng thành công', 'SUCCESS!');
                    self.refreshChilds();
                })
                .catch((error) => {
                    self.$f7.preloader.hide();
                    self.$f7.dialog.alert(error, 'LỖI!');
                })
        },
        pageMounted(){
            if(this.is_verified){
                this.refreshChilds();
            }
        }
    },
    mounted() {
        // this.getChilds(this.user_info.username, this.user_info.fullname);
        this.getAnnouncements();
    }
};
</script>
